import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AddUe, EditUe, UeParams, UeWithPage } from '@app/interfaces/rm/ue';
import { OptionsParams, SelectOption } from '@app/interfaces/sys/dict';
import { environment } from '@env/environment';
import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class UeService {
    private baseUrl = environment.api.services.rm + '/ues';

    constructor(private http: HttpClient) {
    }

    async find(params: UeParams): Promise<UeWithPage> {
        return lastValueFrom(this.http.get<UeWithPage>(`${this.baseUrl}`, {
            params: Object.assign(params),
        }));
    }

    async options(params?: OptionsParams): Promise<SelectOption[]> {
        return lastValueFrom(this.http.get<SelectOption[]>(`${this.baseUrl}/all-options`, {
            params: params ? Object.assign(params) : {}
        }));
    }

    async create(data: AddUe): Promise<void> {
        return lastValueFrom(this.http.post<void>(`${this.baseUrl}`, data));
    }

    async edit(data: EditUe): Promise<void> {
        return lastValueFrom(this.http.put<void>(`${this.baseUrl}`, data));
    }

    async remove(id: number): Promise<void> {
        return lastValueFrom(this.http.delete<void>(`${this.baseUrl}`, {
            params: Object.assign({ id }),
        }));
    }

    async one(option: { id: number }): Promise<any> {
        return lastValueFrom(this.http.get<any>(`${this.baseUrl}/one`, {
            params: Object.assign(option),
        }));
    }
}
